import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ApplicationMixin from "../../../../../mixins/application/broker-application-navigation-mixin";
import ApplicationForm from "./application-form.vue";
import ApplicationDropdownNavigation from "./application-dropdown-navigation.vue";
import ApplicationFlowDropdown from "./header-components/application-flow-dropdown.vue";
import { mapGetters, mapState } from "vuex";
import { delay } from "@Shared/@Utils/utils";
import { validationMixin } from "vuelidate";
import { get, omit } from "lodash";
import { CURRENT_APPLICATION } from "../store/application-getters";
import { defineComponent } from "@vue/composition-api";
import { CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY } from "@Broker/@Modules/main/store/account/account-getters";
import { showToast } from "@Shared/@Utils/constants";
export default defineComponent({
  name: "ApplicationPage",
  title() {
    return this.$t("sidebar.sections.application.application");
  },
  components: {
    ApplicationForm,
    ApplicationDropdownNavigation,
    ApplicationFlowDropdown
  },
  mixins: [validationMixin, ApplicationMixin],
  provide() {
    if (this.$v) {
      const $validator = {};
      _Object$defineProperty($validator, "value", {
        enumerable: true,
        get: () => this.$v
      });
      return {
        $validator
      };
    }
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    },
    currentTab: {
      type: String,
      required: true
    }
  },
  validations() {
    if (!this.currentPage) return {};
    const applicationValidationsModel = {};
    const pageValidations = this.applicationValidations[this.currentPage];
    if (pageValidations !== undefined) {
      applicationValidationsModel[this.currentPage] = pageValidations;
    }
    if (this.currentPage === "main-applicant" && this.coApplicantsEnabled) {
      const coAppValidations = this.applicationValidations["co-applicants"];
      if (coAppValidations !== undefined) {
        applicationValidationsModel["co-applicants"] = coAppValidations;
      }
    }
    return {
      applicationValidationsModel
    };
  },
  data() {
    const applicationTabs = ["main-applicant", "co-applicants", "property", "other-properties", "mortgage-details"];
    const currentPage = this.currentTab;
    return {
      applicationTabs,
      currentPage,
      specialPagesParser: {
        creditReport: "credit-bureau"
      }
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("AccountStore", [CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY])), mapGetters("ApplicationStore", [CURRENT_APPLICATION])), mapState("ApplicationStore", {
    clientDetails(state) {
      return state.clients[this.clientUsername] || {};
    },
    applicationValidations(state) {
      if (!this.coApplicantsEnabled) return omit(state.applicationValidations, "co-applicants");
      return state.applicationValidations;
    }
  })), {}, {
    coApplicantsEnabled() {
      return !!get(this.CURRENT_APPLICATION, "main-applicant.personal-details.coapp");
    },
    applicationValidationsModel() {
      return this.CURRENT_APPLICATION;
    },
    flows() {
      return [{
        title: this.$t("application-flow.flows.purchase-approval"),
        key: "purchase-approval"
      }, {
        title: this.$t("application-flow.flows.refinance-approval"),
        key: "refinance-approval"
      }, {
        title: this.$t("application-flow.flows.purchase-preapproval"),
        key: "purchase-preapproval"
      }, {
        title: this.$t("application-flow.flows.switch-transfer"),
        key: "switch-transfer"
      }];
    },
    validApplicationPages() {
      return ["credit-bureau", "fees", "commissions", "lender-response", "lender-submit", "participants", "internal-notes", "forms", "main-applicant", "co-applicants", "property", "mortgage-details", "other-properties", "documents", "filogix"];
    }
  }),
  watch: {
    currentPage: {
      handler() {
        if (this.CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY) {
          showToast("error", "userViewOnly");
        }
      },
      immediate: true
    }
  },
  mounted() {
    var _context;
    this.$root.$on("navigate-to-field", this.handleNavigateToField);
    if (_includesInstanceProperty(_context = this.mergedPages).call(_context, this.currentTab)) {
      this.navigateTo(`#${this.currentTab}-container`);
      this.handlePageChange(this.currentTab, {
        scrollTop: false
      });
    }
  },
  beforeDestroy() {
    this.$root.$off("navigate-to-field");
  },
  methods: {
    handlePageChange(page, opts = {
      scrollTop: true
    }) {
      var _context2;
      if (_includesInstanceProperty(_context2 = ["direct-to-lender", "credit-bureau"]).call(_context2, page)) {
        this.$router.push({
          name: "application-direct-to-lender",
          params: this.$route.params
        });
      }
      this.currentPage = page;
      if (opts.scrollTop) $(this.$refs.mortgageContainer).scrollTop(0);
      if (opts.target) {
        this.$nextTick(() => {
          const target = $(opts.target);
          target.addClass("highlight animated fadeIn");
          _findInstanceProperty(target).call(target, "input").first().triggerNative("change");
          setTimeout(() => {
            target.removeClass("highlight");
          }, 800);
        });
      }
    },
    isSpecialPathPage(path) {
      return _findIndexInstanceProperty(path).call(path, p => {
        var _context3;
        return _includesInstanceProperty(_context3 = _Object$keys(this.specialPagesParser)).call(_context3, p);
      });
    },
    getPathPage(path) {
      var _context4, _context5;
      let [pathPage, pathIndex] = path;
      //Special Conditions
      const isFirstCoapplicant = pathPage === "co-applicants" && pathIndex === "0";
      const isOtherProperties = _includesInstanceProperty(_context4 = path.join(" ")).call(_context4, "other-properties");
      const isSubmissionDetails = _includesInstanceProperty(_context5 = path[0]).call(_context5, "submission-details");
      if (isFirstCoapplicant || isOtherProperties) pathPage = "main-applicant";
      if (isSubmissionDetails) pathPage = "mortgage-details";
      const matchSpecialPage = this.isSpecialPathPage(path);
      if (matchSpecialPage > 0) {
        pathPage = this.specialPagesParser[path[matchSpecialPage]];
      }
      return pathPage;
    },
    async highlightElement(pathHash) {
      await this.$nextTick();
      let elem = document.getElementById(pathHash);
      if (elem.tagName.toLowerCase() == "input" && elem.classList.contains("postal_code")) {
        elem = elem.closest(".form-group-material");
      }
      elem.classList.add("application-highlight");
      await delay(5000);
      elem.classList.remove("application-highlight");
    },
    async handleNavigateToField(path, pathHash) {
      var _context6;
      const pathPage = this.getPathPage(path);
      if (!_includesInstanceProperty(_context6 = this.validApplicationPages).call(_context6, pathPage)) return;
      if (pathPage !== this.currentPage) {
        this.handlePageChange(pathPage);
      }
      if (this.isSpecialPathPage(path) > 0) return;
      await this.$nextTick();
      await this.$nextTick();
      this.$scrollTo(`#${pathHash}`, 500, {
        container: "#app-data-container",
        force: false,
        cancelable: true,
        offset: -50,
        onDone: () => this.highlightElement(pathHash)
      });
    }
  }
});